import React from 'react'

const BottomFooter = () => {
    return (
        <div className="bottom-footer bg-color-one py-12">
            <style>{`
                .bottom-footer__inner {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 12px;
                    padding: 8px 0;
                }
                @media (max-width: 575px) {
                    .bottom-footer__inner {
                        flex-direction: column;
                        text-align: center;
                        justify-content: center;
                        gap: 8px;
                    }
                }
            `}</style>
            <div className="container container-lg">
                <div className="bottom-footer__inner wow fadeIn" data-wow-duration="0.8s">
                    <p className="bottom-footer__text mb-0 text-sm">
                        Healthy Home © 2026. All Rights Reserved
                    </p>
                    <div className="flex-align gap-8 flex-wrap justify-content-center">
                        <span className="text-heading text-sm">Developed by <a href="https://saitechnosolutions.com/" target='_blanck'>Sai Techno Solutions</a></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BottomFooter
